import { StringUtil } from '@ddt-web/generic-utils';

declare const Highcharts;

/**
 * SeriesCategoryPointTooltip: this tooltip contains series, category and point info.
 */
export class SeriesCategoryPointTooltip {
	public static getFormatter(): Function {
		return function (): string {
			return '<b>' + StringUtil.escapeHtml(this.point.series.name) + '</b>' + StringUtil.escapeHtml(this.point.category)
				+ Highcharts.numberFormat(this.point.y, 2, '.', ',') + '%';
		};
	}
}
